module.exports = __webpack_public_path__ + "img/19.1c1f4cf1.png";